import React from "react";
import { useTranslation } from "react-i18next";
import { Nav, NavItem, NavLink, TabContent, TabPane } from "reactstrap";
import classNames from "classnames";
import { templateDefaultValue } from "@constants/template";
import Preview from "./Preview";
import BannerImages from "../../Common/BannerImages";
import ConnectiviteDivers from "../../Common/ConnectiviteDivers";
import LanguageTable from "../../Common/LanguageTable";
import { useSelector } from "react-redux";

export function ShopInformationPage() {
    const { t } = useTranslation();
    const mainColor = useSelector(
        (state: any) => state.global.infoUser.maincolor
    );
    const [activeTab, setActiveTab] = React.useState<number>(0);

    const detailsImagePath = React.useMemo(
        () => ["Application", "ChoixBoutique", "Default", "ImageDetails"],
        []
    );

    const tabs = [
        {
            title: t("Shop information"),
            content: (
                <div className="banner-container">
                    <section className="text-section">
                        <div className="banner-images">
                            <BannerImages
                                dataPath={detailsImagePath}
                                title="Image shop"
                                size="(png,jpg,jpeg ou webp)"
                            />
                        </div>
                        <LanguageTable
                            path={["Application", "ChoixBoutique", "Default"]}
                            fields={[
                                {
                                    key: "Description",
                                    label: "Description",
                                    placeholder: "Enter the description",
                                },
                            ]}
                            defaultTexts={
                                templateDefaultValue.Application.ChoixBoutique
                                    .Default
                            }
                            sectionTitle="Description boutique"
                        />
                        <ConnectiviteDivers
                            path={[
                                "template",
                                "Application",
                                "ChoixBoutique",
                                "Default",
                                "SocialMedia",
                            ]}
                        />
                    </section>
                </div>
            ),
            customClassName: "",
        },
    ];

    function toggleNav(tab: number) {
        if (activeTab !== tab) {
            setActiveTab(tab);
        }
    }

    return (
        <div className="d-flex justify-content-between">
            <div style={{ width: "65% " }}>
                <div style={{ borderBottom: "1px solid #ddd4d4" }}>
                    <Nav
                        tabs
                        style={{
                            backgroundColor: "white",
                            width: "50px",
                            display: "grid",
                            gridTemplateColumns: `repeat(${tabs.length}, 1fr)`,
                            border: "unset",
                        }}
                    >
                        {tabs.map((element, index) => (
                            <NavItem
                                key={index}
                                className={classNames(
                                    "pb-1",
                                    "d-flex align-items-center text-nowrap",
                                    {
                                        "disable-nav-item__clz":
                                            activeTab !== index,
                                    },
                                    element.customClassName
                                )}
                                style={{
                                    cursor: "pointer",
                                    borderBottom:
                                        activeTab === index
                                            ? `${mainColor} 3px solid`
                                            : "",
                                }}
                            >
                                <NavLink
                                    className={classNames("text-dark w-100", {
                                        "active customer-account-menu-nav-link-active__clz":
                                            activeTab === index,
                                        "customer-account-menu-nav-link-disable__clz":
                                            activeTab !== index,
                                    })}
                                    onClick={() => toggleNav(index)}
                                >
                                    <span
                                        className="px-2"
                                        style={{
                                            font:
                                                "normal normal 600 20px/27px Segoe UI",
                                            marginRight: "20px",
                                        }}
                                    >
                                        {element.title}
                                    </span>
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </div>
                <TabContent activeTab={activeTab} className="h-100">
                    {tabs.map((element, index) => (
                        <TabPane
                            tabId={index}
                            key={index}
                            style={{ height: "90%" }}
                        >
                            {element.content}
                        </TabPane>
                    ))}
                </TabContent>
            </div>
            <div style={{ width: "35%" }}>
                <Preview />
            </div>
        </div>
    );
}
